import axios from "../axios";

// Service Intervals
export async function fetchVehicleServiceIntervals(params) {
  return axios({ method: "get", url: "/vehicle_service_intervals", params })
    .then((r) => r.data)
    .catch((e) => e.response?.data || e);
}

export async function createVehicleServiceInterval(payload) {
  return axios
    .post("/vehicle_service_intervals", { vehicle_service_interval: payload })
    .then((r) => r.data)
    .catch((e) => e);
}

export async function updateVehicleServiceInterval(id, payload) {
  return axios
    .put(`/vehicle_service_intervals/${id}`, { vehicle_service_interval: payload })
    .then((r) => r.data)
    .catch((e) => e);
}

export async function fetchVehicleServiceInterval(id) {
  return axios
    .get(`/vehicle_service_intervals/${id}`)
    .then((r) => r.data)
    .catch((e) => e.response?.data || e);
}

// Service Entries
export async function fetchVehicleServices(params) {
  return axios({ method: "get", url: "/vehicle_services", params })
    .then((r) => r.data)
    .catch((e) => e.response?.data || e);
}

export async function fetchVehicleService(id) {
  return axios
    .get(`/vehicle_services/${id}`)
    .then((r) => r.data)
    .catch((e) => e.response?.data || e);
}

export async function createVehicleService(payload) {
  return axios
    .post("/vehicle_services", { vehicle_service: payload })
    .then((r) => r.data)
    .catch((e) => e);
}

export async function updateVehicleService(id, payload) {
  return axios
    .put(`/vehicle_services/${id}`, { vehicle_service: payload })
    .then((r) => r.data)
    .catch((e) => e);
}


